import { ApiRequestError } from '@access-cms/api-client';

export const SSN_IDENTITY_MISMATCH_MESSAGE = 'This social security number does not match the one from your account.';

export function getSsnFieldErrorMessage(error: ApiRequestError): string {
  const fieldMessage = error.errors?.find((item) => item.field === 'ssn')?.message;
  if (typeof fieldMessage === 'string' && fieldMessage.length > 0) {
    return fieldMessage;
  }

  if (error.message.length > 0) {
    return error.message;
  }

  return SSN_IDENTITY_MISMATCH_MESSAGE;
}
